import { TypographyV3 } from '@jouzen/ecom-components';
import { type RichTranslationValues } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';

import RichText from '../RichText';

interface LegalParagraphProps {
  readonly tx: MessageKey;
  readonly className?: string;
  readonly values?: RichTranslationValues;
}

const LegalParagraph = ({
  tx: text,
  className = '',
  values,
}: LegalParagraphProps) => {
  const copy = values ? (
    <RichText messageKey={text} tValues={values} />
  ) : (
    <RichText messageKey={text} />
  );

  return (
    <TypographyV3 Element="p" className={className}>
      {copy}
    </TypographyV3>
  );
};

export default LegalParagraph;
